import { parseReferenceViewID } from './parseReferenceViewID.ts';
import { ReferenceViewID } from './types.ts';

export function isReferenceViewID(s: unknown): s is ReferenceViewID {
  return typeof s === 'string' && parseReferenceViewID(s) !== null;
}
